import { render, staticRenderFns } from "./upgradeContractPackageTable.vue?vue&type=template&id=3d3a7d6f"
import script from "./upgradeContractPackageTable.vue?vue&type=script&lang=js"
export * from "./upgradeContractPackageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports